import fetch from 'utils/fetch'

export function loginByname (data) {
  return fetch({
    url: `${process.env.LOGIN_API}/sso/login/doLogin`,
    method: 'post',
    data
  })
}
export function getValidatecaptcha () {
  return fetch({
    url: `${process.env.LOGIN_API}/sso/media/getCaptcha`,
    methods: 'get'
  })
}
export function Validatecaptcha (data) {
  return fetch({
    url: `${process.env.LOGIN_API}/sso/media/validateCaptcha`,
    method: 'post',
    data
  })
}
export function checkDuplication (data) {
  return fetch({
    url: `${process.env.LOGIN_API}/sso/user/checkDuplication`,
    method: 'post',
    data
  })
}
export function signUp (data) {
  return fetch({
    url: `${process.env.LOGIN_API}/sso/user/register`,
    method: 'post',
    data
  })
}
export function getCaptcha (data) {
  return fetch({
    url: `${process.env.LOGIN_API}/sso/media/getCaptcha`,
    method: 'post',
    data
  })
}
export function sendEmailVerify (data) {
  return fetch({
    url: `${process.env.LOGIN_API}/sso/user/sendEmailVerify`,
    method: 'post',
    data
  })
}
// 权限接口
export function getUsersRoles (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/role/getRoleByUserIds`,
    method: 'post',
    data
  })
}
export function visitorLogin () {
  return fetch({
    url: `${process.env.LOGIN_API}/sso/login/visitorLogin`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js